import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { WHATSPP_LINK, KHIDMAT_DETAILS } from "../core/constant";

const Navbar = ({ user, handleLogout }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isKhidmatDropdownOpen, setIsKhidmatDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsKhidmatDropdownOpen(false);
            }
        };

        if (isKhidmatDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }
    }, [isKhidmatDropdownOpen]);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const toggleKhidmatDropdown = () => {
        setIsKhidmatDropdownOpen(!isKhidmatDropdownOpen);
    };

    return (
        <nav className="bg-white shadow-sm sticky top-0 z-50 backdrop-blur-lg border-b border-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    {/* Logo/Brand Section */}
                    <div className="flex items-center">
                        <Link to="/" className="flex items-center space-x-3">
                            <div className="flex-shrink-0">
                                <img
                                    src="/shehrullah-logo.jpeg"
                                    alt="Shehrullah Khidmat Logo"
                                    className="h-12 w-12 rounded-full object-cover"
                                />
                            </div>
                            <span className="text-gray-800 font-bold text-xl hidden sm:block font-serif">
                                Shehrullah Khidmat Sharaf
                            </span>
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-1">
                        <Link
                            to="/"
                            className="text-gray-700 hover:text-amber-600 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 relative after:absolute after:bottom-0 after:left-1/2 after:w-0 after:h-0.5 after:bg-amber-600 after:transition-all after:duration-300 hover:after:w-full hover:after:left-0"
                        >
                            Home
                        </Link>

                        {/* Khidmat Services Dropdown */}
                        <div className="relative" ref={dropdownRef}>
                            <button
                                onClick={toggleKhidmatDropdown}
                                className="text-gray-700 hover:text-amber-600 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 relative after:absolute after:bottom-0 after:left-1/2 after:w-0 after:h-0.5 after:bg-amber-600 after:transition-all after:duration-300 hover:after:w-full hover:after:left-0 flex items-center"
                            >
                                Khidmats
                                <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                                </svg>
                            </button>

                            {/* Dropdown Menu */}
                            {isKhidmatDropdownOpen && (
                                <div className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                                    {KHIDMAT_DETAILS.map((service) => (
                                        <Link
                                            key={service.id}
                                            to={`/khidmat/${service.key.toLowerCase()}`}
                                            onClick={() => setIsKhidmatDropdownOpen(false)}
                                            className="block px-4 py-3 text-sm text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors duration-150 border-b border-gray-100 last:border-b-0"
                                        >
                                            <div className="font-medium">{service.title}</div>
                                            <div className="text-xs text-gray-500 mt-1">{service.subTitle}</div>
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </div>

                        {user && (
                            <>
                                <Link
                                    to="/dashboard"
                                    className="text-gray-700 hover:text-amber-600 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 relative after:absolute after:bottom-0 after:left-1/2 after:w-0 after:h-0.5 after:bg-amber-600 after:transition-all after:duration-300 hover:after:w-full hover:after:left-0"
                                >
                                    Dashboard
                                </Link>
                                <Link
                                    to="/attendance"
                                    className="text-gray-700 hover:text-amber-600 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 relative after:absolute after:bottom-0 after:left-1/2 after:w-0 after:h-0.5 after:bg-amber-600 after:transition-all after:duration-300 hover:after:w-full hover:after:left-0"
                                >
                                    Attendance
                                </Link>
                            </>
                        )}


                        {/* Register Button - Always visible in main navigation */}
                        <a
                            href={WHATSPP_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-md hover:shadow-lg transform hover:scale-105 text-sm ml-2"
                        >
                            Register
                        </a>
                    </div>

                    {/* Desktop Auth Section */}
                    <div className="hidden md:flex items-center space-x-4">
                        {user ? (
                            <div className="flex items-center space-x-3">
                                <div className="text-gray-700 text-sm">
                                    Welcome, {user.email?.split('@')[0]}
                                </div>
                                <button
                                    onClick={handleLogout}
                                    className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
                                >
                                    Logout
                                </button>
                            </div>
                        ) : (
                            <Link
                                to="/login"
                                className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
                            >
                                Login
                            </Link>
                        )}
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center space-x-2">
                        {/* Mobile Register Button - Always visible */}
                        <a
                            href={WHATSPP_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-3 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-md text-xs"
                        >
                            Register
                        </a>

                        <button
                            onClick={toggleMobileMenu}
                            className="text-gray-700 hover:text-amber-600 p-2 rounded-lg transition-all duration-200"
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                {isMobileMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile Navigation Menu */}
                {isMobileMenuOpen && (
                    <div className="md:hidden border-t border-gray-200">
                        <div className="px-2 pt-2 pb-3 space-y-1 bg-white shadow-lg rounded-b-lg">
                            <Link
                                to="/"
                                onClick={() => setIsMobileMenuOpen(false)}
                                className="text-gray-700 hover:text-amber-600 hover:bg-amber-50 block px-3 py-2 rounded-lg text-base font-medium transition-all duration-200"
                            >
                                Home
                            </Link>

                            {/* Khidmat Services Mobile */}
                            <div className="space-y-1">
                                <div className="text-gray-900 font-semibold px-3 py-2 text-sm border-b border-gray-200">Khidmat Services</div>
                                {KHIDMAT_DETAILS.map((service) => (
                                    <Link
                                        key={service.id}
                                        to={`/khidmat/${service.key.toLowerCase()}`}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="text-gray-600 hover:text-amber-600 hover:bg-amber-50 block px-6 py-2 rounded-lg text-sm transition-all duration-200 ml-3"
                                    >
                                        {service.title}
                                    </Link>
                                ))}
                            </div>

                            {user && (
                                <>
                                    <Link
                                        to="/dashboard"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="text-gray-700 hover:text-amber-600 hover:bg-amber-50 block px-3 py-2 rounded-lg text-base font-medium transition-all duration-200"
                                    >
                                        Dashboard
                                    </Link>
                                    <Link
                                        to="/attendance"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="text-gray-700 hover:text-amber-600 hover:bg-amber-50 block px-3 py-2 rounded-lg text-base font-medium transition-all duration-200"
                                    >
                                        Attendance
                                    </Link>
                                </>
                            )}

                            {/* Mobile Auth Section */}
                            <div className="pt-4 border-t border-gray-200">
                                {user ? (
                                    <div className="space-y-2">
                                        <div className="text-gray-700 px-3 py-2 text-sm">
                                            Welcome, {user.email?.split('@')[0]}
                                        </div>
                                        <button
                                            onClick={() => {
                                                handleLogout();
                                                setIsMobileMenuOpen(false);
                                            }}
                                            className="w-full text-left bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-3 py-2 rounded-lg text-base font-medium transition-all duration-200"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                ) : (
                                    <Link
                                        to="/login"
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className="block w-full bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white px-3 py-2 rounded-lg text-base font-medium transition-all duration-200 text-center"
                                    >
                                        Login
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    );
};

export default Navbar;